import axios from 'axios'
const state = () => ({
    faq: []
})

const getters = {
    faq(state) {
        return state.faq
    }
}

const mutations = {
    GET_FAQ(state, payload){
        state.faq = payload
    },
}

const actions = {
    getFaq({commit}){
        axios.get(`https://api.geomalaka.uz/api/main/savol-javoblar/`)
            .then((res)=>{
                commit("GET_FAQ", res.data)
            })
            .catch((error)=>{console.log(error)})
    },
}

export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
